import { render, staticRenderFns } from "./menu-button-icon.vue?vue&type=template&id=2c586a9a&functional=true"
import script from "./menu-button-icon.vue?vue&type=script&lang=js"
export * from "./menu-button-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports